module.exports = __webpack_public_path__ + "static/img/index-top-right-2.ca61a13c.png";